<template>
  <div style="width: 100%">
    <div
      v-if="!unblockBusy"
      class="login__form">
      <div>
        <v-alert
          v-model="isSessionBlocked"
          type="error"
          class="ma-0"
        >
          Przekroczona została liczba błędnych logowań.
          Sesja została chwilowo zablokowana,
          spróbuj ponownie później.
        </v-alert>
        <v-alert
          v-model="unblockSuccess"
          type="success"
          dismissible
          class="ma-0"
        >
          Twoje konto zostało odblkowane.<br/>Możesz się zalogować.
        </v-alert>
        <v-alert
          v-model="error"
          dismissible
          class="ma-0"
          type="error"
        >
          {{errorMsg}}
        </v-alert>
      </div>
      <form>
        <v-layout>
          <v-flex xs12>
            <v-card class="px-4 py-4">
              <v-card-title primary-title class="px-0 pt-0">
                <div>
                  <div class="headline">Logowanie</div>
                </div>
              </v-card-title>
              <form class="pb-4">
                <div class="pb-2">
                  <v-text-field
                    v-model="pin"
                    :disabled="isSessionBlocked"
                    label="Kod PIN"
                    trim
                    :type="'password'"
                    :error-messages="errors.collect('pin')"
                    v-validate="'required|max:10|min:6|alpha_num'"
                    name="pin"
                    data-vv-name="pin"
                    data-vv-as="PIN"
                    required
                  ></v-text-field>
                </div>
                <v-text-field
                  v-model="email"
                  :disabled="isSessionBlocked"
                  trim
                  label="Login"
                  :error-messages="errors.collect('email')"
                  v-validate="'required|email'"
                  data-vv-name="email"
                  data-vv-as="login"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :disabled="isSessionBlocked"
                  trim
                  label="Hasło"
                  :type="'password'"
                  :error-messages="errors.collect('password')"
                  v-validate="'required'"
                  data-vv-name="password"
                  data-vv-as="hasła"
                  required
                ></v-text-field>
              </form>
              <v-card-actions>
                <v-layout align-center>
                  <v-flex xs6>
                    <router-link class="primary--text" to="/przypomnij-haslo">
                      Nie pamiętam hasła
                    </router-link>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right">
                    <v-btn
                      @click.native="loginUser"
                      color="primary"
                      :loading="busy"
                      :disabled="busy || isSessionBlocked"
                    >Zaloguj</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
              <ServerErrors class="pt-3" :errorsItems="serverErrors" />
            </v-card>
          </v-flex>
        </v-layout>
      </form>
    </div>
    <div
      v-if="unblockBusy"
      class="py-4 text-xs-center">
      <v-progress-circular
        :size="30"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import ServerErrors from '../common/Errors/ServerErrors.vue';
import { login, unblockUser } from '../../repository/auth/index';
import { saveToken } from '../../service/axios';
import { getError } from '../../helpers/helpers';
import config from './../../config';

export default {
  name: 'login-form',
  data: () => ({
    pin: process.env.NODE_ENV === 'production' ? null : '1234567890',
    email: process.env.NODE_ENV === 'production' ? null : 'admin@netizens.pl',
    password: process.env.NODE_ENV === 'production' ? null : 'qwerty123',
    attempts: 0,
    // pin: null,
    // email: null,
    // password: null,
    isSessionBlocked: false,
    unblockSuccess: false,
    unblockBusy: false,
    error: false,
    errorMsg: null,
    busy: false,
    serverErrors: [],
    errorInterval: null,
  }),
  components: {
    ServerErrors,
  },
  computed: {
    ...mapGetters('app', [
      'token',
    ]),
    unblockData() {
      const routeData = this.$route.params;
      const hasData = routeData.id && routeData.token;
      return hasData ? routeData : false;
    },
  },
  methods: {
    ...mapActions('user', [
      'setUser',
    ]),
    ...mapActions('app', [
      'setTokens',
      'clearErrors',
    ]),
    ...mapActions('app', [
      'setSnackBar',
    ]),
    setBlockedSesstionCookie() {
      const fiveMinutes = new Date(new Date().getTime() + (5 * 60 * 1000));
      Cookies.set('blocked', true, {
        expires: fiveMinutes,
      });
    },
    redirectToDashboard() {
      if (this.token) {
        this.$router.push('/dashboard');
      }
    },
    setErrorInterval() {
      if (!this.errorInterval) {
        this.errorInterval = setInterval(() => {
          this.verifySession();
        }, 1000);
      }
    },
    clearErrorInterval() {
      if (this.errorInterval) {
        clearInterval(this.errorInterval);
      }
    },
    verifySession() {
      const blockedCookie = Cookies.get('blocked');
      if (blockedCookie) {
        this.isSessionBlocked = JSON.parse(blockedCookie);
        this.setErrorInterval();
      } else {
        this.isSessionBlocked = false;
        this.attempts = 0;
        this.clearErrorInterval();
      }
    },
    verifyAttempt() {
      this.attempts += 1;
      if (config.maxAttempts === this.attempts) {
        this.isSessionBlocked = true;
        this.setBlockedSesstionCookie();
        this.setErrorInterval();
      }
    },
    clearFormErrors() {
      this.$validator.reset();
      this.error = false;
      this.errorMsg = null;
      this.serverErrors = [];
      this.unblockSuccess = false;
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
      if (errorData.response.data.data.increment_attempts) {
        this.verifyAttempt();
      }
      if (errorData.response.data && errorData.response.data.data) {
        this.getServerErrors(errorData.response.data.data);
      }
    },
    async unblock() {
      if (this.unblockData) {
        this.unblockBusy = true;
        this.clearFormErrors();
        try {
          await unblockUser(this.unblockData);
          this.setSnackBar('Twoje konto zostało odblkowane.');
          this.unblockBusy = false;
          this.unblockSuccess = true;
          this.$router.push({ path: '/login' });
        } catch (e) {
          this.unblockBusy = false;
          this.getError(e);
          this.$router.push({ path: '/login' });
        }
      }
    },
    loginUser() {
      if (this.isSessionBlocked) return;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.busy = true;
          this.login();
        }
      });
    },
    getServerErrors(errors) {
      const filedKeys = Object.keys(errors);
      filedKeys.forEach((fieldKey) => {
        const fieldErros = errors[fieldKey];
        if (!fieldErros[0] || fieldErros.length <= 0) return;
        fieldErros.forEach((err) => {
          const field = this.$validator.fields.find({
            name: fieldKey,
            scope: this.$options.scope,
          });
          if (field) {
            this.$validator.errors.add({
              id: field.id,
              field: fieldKey,
              msg: err,
              scope: this.$options.scope,
            });
          } else if (!this.serverErrors.includes(err)) {
            this.serverErrors.push(err);
          }
        });
      });
    },
    async login() {
      try {
        this.clearFormErrors();
        const loginData = await login({
          pin: this.pin,
          email: this.email,
          password: this.password,
        });
        const { refresh, token, user } = loginData.data.data;
        this.setUser(user);
        this.setTokens({ token, refresh });
        this.clearErrors();
        this.redirectToDashboard();
        saveToken(token);
        this.busy = false;
      } catch (e) {
        this.getError(e);
      }
    },
  },
  beforeDestroy() {
    this.clearFormErrors();
    this.clearErrorInterval();
  },
  mounted() {
    this.verifySession();
    this.redirectToDashboard();
    this.unblock();
  },
};
</script>
